/* tslint:disable */
/* eslint-disable */
/**
 * Agoda.PropertyOnboarding
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { MissingPropertyTypeRequest } from '../models';
// @ts-ignore
import type { PropertySelectionViewModel } from '../models';
// @ts-ignore
import type { PropertyTypesResponse } from '../models';
// @ts-ignore
import type { UnfinishedPropertyResponse } from '../models';
/**
 * PropertySelectionApi - axios parameter creator
 * @export
 */
export const PropertySelectionApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} culture 
         * @param {GetOriginByPropertyTypePropertyTypeEnum} [propertyType] 
         * @param {boolean} [isSingleUnit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOriginByPropertyType: async (culture: string, propertyType?: GetOriginByPropertyTypePropertyTypeEnum, isSingleUnit?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'culture' is not null or undefined
            assertParamExists('getOriginByPropertyType', 'culture', culture)
            const localVarPath = `/{culture}/list-my-property/api/property-selection/getOriginByPropertyType`
                .replace(`{${"culture"}}`, encodeURIComponent(String(culture)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (propertyType !== undefined) {
                localVarQueryParameter['propertyType'] = propertyType;
            }

            if (isSingleUnit !== undefined) {
                localVarQueryParameter['isSingleUnit'] = isSingleUnit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} culture 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPropertySelectionViewModel: async (culture: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'culture' is not null or undefined
            assertParamExists('getPropertySelectionViewModel', 'culture', culture)
            const localVarPath = `/{culture}/list-my-property/api/property-selection`
                .replace(`{${"culture"}}`, encodeURIComponent(String(culture)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} culture 
         * @param {GetPropertyTypesTypeEnum} [type] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPropertyTypes: async (culture: string, type?: GetPropertyTypesTypeEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'culture' is not null or undefined
            assertParamExists('getPropertyTypes', 'culture', culture)
            const localVarPath = `/{culture}/list-my-property/api/property-selection/getPropertyTypes`
                .replace(`{${"culture"}}`, encodeURIComponent(String(culture)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} culture 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUnfinishedProperties: async (culture: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'culture' is not null or undefined
            assertParamExists('getUnfinishedProperties', 'culture', culture)
            const localVarPath = `/{culture}/list-my-property/api/property-selection/getUnfinishedProperties`
                .replace(`{${"culture"}}`, encodeURIComponent(String(culture)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} culture 
         * @param {string} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitImportAnotherPlatform: async (culture: string, body?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'culture' is not null or undefined
            assertParamExists('submitImportAnotherPlatform', 'culture', culture)
            const localVarPath = `/{culture}/list-my-property/api/property-selection/submitImportAnotherPlatform`
                .replace(`{${"culture"}}`, encodeURIComponent(String(culture)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} culture 
         * @param {MissingPropertyTypeRequest} [missingPropertyTypeRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitMissingPropertyType: async (culture: string, missingPropertyTypeRequest?: MissingPropertyTypeRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'culture' is not null or undefined
            assertParamExists('submitMissingPropertyType', 'culture', culture)
            const localVarPath = `/{culture}/list-my-property/api/property-selection/submitMissingPropertyType`
                .replace(`{${"culture"}}`, encodeURIComponent(String(culture)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(missingPropertyTypeRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PropertySelectionApi - functional programming interface
 * @export
 */
export const PropertySelectionApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PropertySelectionApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} culture 
         * @param {GetOriginByPropertyTypePropertyTypeEnum} [propertyType] 
         * @param {boolean} [isSingleUnit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOriginByPropertyType(culture: string, propertyType?: GetOriginByPropertyTypePropertyTypeEnum, isSingleUnit?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOriginByPropertyType(culture, propertyType, isSingleUnit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PropertySelectionApi.getOriginByPropertyType']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} culture 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPropertySelectionViewModel(culture: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PropertySelectionViewModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPropertySelectionViewModel(culture, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PropertySelectionApi.getPropertySelectionViewModel']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} culture 
         * @param {GetPropertyTypesTypeEnum} [type] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPropertyTypes(culture: string, type?: GetPropertyTypesTypeEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PropertyTypesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPropertyTypes(culture, type, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PropertySelectionApi.getPropertyTypes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} culture 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUnfinishedProperties(culture: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<UnfinishedPropertyResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUnfinishedProperties(culture, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PropertySelectionApi.getUnfinishedProperties']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} culture 
         * @param {string} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async submitImportAnotherPlatform(culture: string, body?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.submitImportAnotherPlatform(culture, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PropertySelectionApi.submitImportAnotherPlatform']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} culture 
         * @param {MissingPropertyTypeRequest} [missingPropertyTypeRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async submitMissingPropertyType(culture: string, missingPropertyTypeRequest?: MissingPropertyTypeRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.submitMissingPropertyType(culture, missingPropertyTypeRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PropertySelectionApi.submitMissingPropertyType']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PropertySelectionApi - factory interface
 * @export
 */
export const PropertySelectionApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PropertySelectionApiFp(configuration)
    return {
        /**
         * 
         * @param {string} culture 
         * @param {GetOriginByPropertyTypePropertyTypeEnum} [propertyType] 
         * @param {boolean} [isSingleUnit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOriginByPropertyType(culture: string, propertyType?: GetOriginByPropertyTypePropertyTypeEnum, isSingleUnit?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<number> {
            return localVarFp.getOriginByPropertyType(culture, propertyType, isSingleUnit, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} culture 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPropertySelectionViewModel(culture: string, options?: RawAxiosRequestConfig): AxiosPromise<PropertySelectionViewModel> {
            return localVarFp.getPropertySelectionViewModel(culture, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} culture 
         * @param {GetPropertyTypesTypeEnum} [type] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPropertyTypes(culture: string, type?: GetPropertyTypesTypeEnum, options?: RawAxiosRequestConfig): AxiosPromise<PropertyTypesResponse> {
            return localVarFp.getPropertyTypes(culture, type, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} culture 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUnfinishedProperties(culture: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<UnfinishedPropertyResponse>> {
            return localVarFp.getUnfinishedProperties(culture, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} culture 
         * @param {string} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitImportAnotherPlatform(culture: string, body?: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.submitImportAnotherPlatform(culture, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} culture 
         * @param {MissingPropertyTypeRequest} [missingPropertyTypeRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitMissingPropertyType(culture: string, missingPropertyTypeRequest?: MissingPropertyTypeRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.submitMissingPropertyType(culture, missingPropertyTypeRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PropertySelectionApi - interface
 * @export
 * @interface PropertySelectionApi
 */
export interface PropertySelectionApiInterface {
    /**
     * 
     * @param {string} culture 
     * @param {GetOriginByPropertyTypePropertyTypeEnum} [propertyType] 
     * @param {boolean} [isSingleUnit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropertySelectionApiInterface
     */
    getOriginByPropertyType(culture: string, propertyType?: GetOriginByPropertyTypePropertyTypeEnum, isSingleUnit?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<number>;

    /**
     * 
     * @param {string} culture 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropertySelectionApiInterface
     */
    getPropertySelectionViewModel(culture: string, options?: RawAxiosRequestConfig): AxiosPromise<PropertySelectionViewModel>;

    /**
     * 
     * @param {string} culture 
     * @param {GetPropertyTypesTypeEnum} [type] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropertySelectionApiInterface
     */
    getPropertyTypes(culture: string, type?: GetPropertyTypesTypeEnum, options?: RawAxiosRequestConfig): AxiosPromise<PropertyTypesResponse>;

    /**
     * 
     * @param {string} culture 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropertySelectionApiInterface
     */
    getUnfinishedProperties(culture: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<UnfinishedPropertyResponse>>;

    /**
     * 
     * @param {string} culture 
     * @param {string} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropertySelectionApiInterface
     */
    submitImportAnotherPlatform(culture: string, body?: string, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @param {string} culture 
     * @param {MissingPropertyTypeRequest} [missingPropertyTypeRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropertySelectionApiInterface
     */
    submitMissingPropertyType(culture: string, missingPropertyTypeRequest?: MissingPropertyTypeRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

}

/**
 * PropertySelectionApi - object-oriented interface
 * @export
 * @class PropertySelectionApi
 * @extends {BaseAPI}
 */
export class PropertySelectionApi extends BaseAPI implements PropertySelectionApiInterface {
    /**
     * 
     * @param {string} culture 
     * @param {GetOriginByPropertyTypePropertyTypeEnum} [propertyType] 
     * @param {boolean} [isSingleUnit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropertySelectionApi
     */
    public getOriginByPropertyType(culture: string, propertyType?: GetOriginByPropertyTypePropertyTypeEnum, isSingleUnit?: boolean, options?: RawAxiosRequestConfig) {
        return PropertySelectionApiFp(this.configuration).getOriginByPropertyType(culture, propertyType, isSingleUnit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} culture 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropertySelectionApi
     */
    public getPropertySelectionViewModel(culture: string, options?: RawAxiosRequestConfig) {
        return PropertySelectionApiFp(this.configuration).getPropertySelectionViewModel(culture, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} culture 
     * @param {GetPropertyTypesTypeEnum} [type] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropertySelectionApi
     */
    public getPropertyTypes(culture: string, type?: GetPropertyTypesTypeEnum, options?: RawAxiosRequestConfig) {
        return PropertySelectionApiFp(this.configuration).getPropertyTypes(culture, type, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} culture 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropertySelectionApi
     */
    public getUnfinishedProperties(culture: string, options?: RawAxiosRequestConfig) {
        return PropertySelectionApiFp(this.configuration).getUnfinishedProperties(culture, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} culture 
     * @param {string} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropertySelectionApi
     */
    public submitImportAnotherPlatform(culture: string, body?: string, options?: RawAxiosRequestConfig) {
        return PropertySelectionApiFp(this.configuration).submitImportAnotherPlatform(culture, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} culture 
     * @param {MissingPropertyTypeRequest} [missingPropertyTypeRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropertySelectionApi
     */
    public submitMissingPropertyType(culture: string, missingPropertyTypeRequest?: MissingPropertyTypeRequest, options?: RawAxiosRequestConfig) {
        return PropertySelectionApiFp(this.configuration).submitMissingPropertyType(culture, missingPropertyTypeRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
  * @export
  * @enum {string}
  */
export enum GetOriginByPropertyTypePropertyTypeEnum {
    NUMBER_0 = 0,
    NUMBER_28 = 28,
    NUMBER_29 = 29,
    NUMBER_33 = 33,
    NUMBER_34 = 34,
    NUMBER_35 = 35,
    NUMBER_37 = 37,
    NUMBER_38 = 38,
    NUMBER_103 = 103,
    NUMBER_105 = 105,
    NUMBER_106 = 106,
    NUMBER_107 = 107,
    NUMBER_108 = 108,
    NUMBER_109 = 109,
    NUMBER_110 = 110,
    NUMBER_111 = 111,
    NUMBER_112 = 112,
    NUMBER_113 = 113,
    NUMBER_114 = 114,
    NUMBER_115 = 115,
    NUMBER_120 = 120,
    NUMBER_131 = 131,
    NUMBER_132 = 132,
    NUMBER_133 = 133,
    NUMBER_134 = 134,
    NUMBER_135 = 135,
    NUMBER_136 = 136,
    NUMBER_137 = 137,
    NUMBER_138 = 138,
    NUMBER_139 = 139,
    NUMBER_140 = 140,
    NUMBER_141 = 141,
    NUMBER_142 = 142,
    NUMBER_143 = 143,
    NUMBER_144 = 144,
    NUMBER_145 = 145,
    NUMBER_146 = 146,
    NUMBER_147 = 147,
    NUMBER_148 = 148,
    NUMBER_149 = 149
}
/**
  * @export
  * @enum {string}
  */
export enum GetPropertyTypesTypeEnum {
    NUMBER_1 = 1,
    NUMBER_2 = 2,
    NUMBER_3 = 3
}
